module.exports = __webpack_public_path__ + "static/media/marron.341a3e84.png";